import _createClass from "@babel/runtime/helpers/createClass";
import DefaultFieldInstaller from "./DefaultFieldInstaller";
/**
 * @private
 * @memberof module:fields
 */

export var Field =
/*#__PURE__*/
function () {
  function Field() {}

  var _proto = Field.prototype;

  _proto.getClass = function getClass() {
    return this.constructor;
  };

  _proto.references = function references(model) {
    return false;
  };

  _proto.getThroughModelName = function getThroughModelName(fieldName, model) {
    return null;
  };

  _createClass(Field, [{
    key: "installerClass",
    get: function get() {
      return DefaultFieldInstaller;
    }
  }, {
    key: "installsForwardsVirtualField",
    get: function get() {
      return false;
    }
  }, {
    key: "installsBackwardsDescriptor",
    get: function get() {
      return false;
    }
  }, {
    key: "installsBackwardsVirtualField",
    get: function get() {
      return false;
    }
  }, {
    key: "index",
    get: function get() {
      return false;
    }
  }]);

  return Field;
}();
export default Field;